import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";
import Disclaimer from "./components/Disclaimer.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import FacebookPixelPageView from "./components/FacebookPixelPageView.jsx";
import WaterReminder from "./components/WaterReminder.jsx";
import Home from "./scenes/Home.jsx";
import Therapy from "./scenes/Therapy/index.jsx";
import NLSHunter from "./scenes/Therapy/NLSHunter.jsx";
import RedLightSessions from "./scenes/Therapy/RedLightSessions.jsx";
import BEMERSessions from "./scenes/Therapy/BEMERSessions.jsx";
import TRTherapy from "./scenes/Therapy/TRTherapy.jsx";
import HydroVitality from "./scenes/Therapy/HydroVitality.jsx";
import SwedishMassage from "./scenes/Therapy/SwedishMassage.jsx";
import CuppingTherapy from "./scenes/Therapy/CuppingTherapy.jsx";
import BioresonanceTherapy from "./scenes/Therapy/BioresonanceTherapy.jsx";
import Allergies from "./scenes/Therapy/Allergies.jsx";
import Addictions from "./scenes/Therapy/Addictions.jsx";
import Depression from "./scenes/Therapy/Depression.jsx";
import SkinProblems from "./scenes/Therapy/SkinProblems.jsx";
import LymeDisease from "./scenes/Therapy/LymeDisease.jsx";
import Arthritis from "./scenes/Therapy/Arthritis.jsx";
import MuscleJointSpine from "./scenes/Therapy/MuscleJointSpine.jsx";
import Prices from "./scenes/Prices.jsx";
import Gallery from "./scenes/Gallery.jsx";
import Contact from "./scenes/Contact.jsx";
import AboutUs from "./scenes/AboutUs.jsx";
import FAQ from "./scenes/FAQ.jsx";
import Terms from "./scenes/Terms.jsx";
import Privacy from "./scenes/Privacy.jsx";
import { useState } from "react";

function App() {
  const [selectedPage, setSelectedPage] = useState('home');

  return (
    <Router>
      <ScrollToTop />
      <FacebookPixelPageView />
      <div className="app">
        <Navbar 
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/therapy" element={<Therapy />} />
          <Route path="/therapy/nls-hunter" element={<NLSHunter />} />
          <Route path="/therapy/red-light-sessions" element={<RedLightSessions />} />
          <Route path="/therapy/bemer-sessions" element={<BEMERSessions />} />
          <Route path="/therapy/tr-therapy" element={<TRTherapy />} />
          <Route path="/therapy/hydro-vitality" element={<HydroVitality />} />
          <Route path="/therapy/swedish-massage" element={<SwedishMassage />} />
          <Route path="/therapy/cupping-therapy" element={<CuppingTherapy />} />
          <Route path="/therapy/bioresonance-therapy" element={<BioresonanceTherapy />} />
          <Route path="/therapy/bioresonance-therapy/allergies" element={<Allergies />} />
          <Route path="/therapy/bioresonance-therapy/addictions" element={<Addictions />} />
          <Route path="/therapy/bioresonance-therapy/depression" element={<Depression />} />
          <Route path="/therapy/bioresonance-therapy/skin-problems" element={<SkinProblems />} />
          <Route path="/therapy/bioresonance-therapy/lyme-disease" element={<LymeDisease />} />
          <Route path="/therapy/bioresonance-therapy/arthritis" element={<Arthritis />} />
          <Route path="/therapy/bioresonance-therapy/muscle-joint-spine" element={<MuscleJointSpine />} />
          <Route path="/prices" element={<Prices />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <WaterReminder />
        <Disclaimer />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
